module.exports = __webpack_public_path__ + "img/remiseduprix.3d6801f2.jpg";